import * as Yup from 'yup';

export const accommodationIdValidationSchema = Yup.number()
  .required('Ubytovací zařízení musí být vybráno')
  .min(1, 'Ubytovací zařízení musí být vybráno');

export const nameValidationSchema = Yup.string().required('Název je povinný');
